// extracted by mini-css-extract-plugin
module.exports = {"slideshow":"R_bw","view":"R_dj","slide":"R_by","img":"R_dk","btn":"R_R","right":"R_dl","indicators":"R_dm","indicator":"R_dn","active":"R_dp"};